import { Button } from '@ntconsult/aluma-react';
import { SlidersHorizontal } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferenceDateField } from './ReferenceDateField';

type CheckToolbarProps = {
  date: Date | null;
  appliedDate: string | undefined;
  onDateChange: (date: Date | null) => void;
  dateHint: string;
  /** Contagem já traduzida (cada tela diz o que conta); `undefined` esconde. */
  totalLabel?: string;
  onOpenFilters: () => void;
  actions?: ReactNode;
};

export function CheckToolbar({
  date,
  appliedDate,
  onDateChange,
  dateHint,
  totalLabel,
  onOpenFilters,
  actions,
}: CheckToolbarProps) {
  const { t } = useTranslation('alocacao');
  return (
    <div className="flex flex-wrap items-start gap-4">
      <ReferenceDateField
        value={date}
        appliedDate={appliedDate}
        onChange={onDateChange}
        hint={dateHint}
      />
      <div className="mt-[26px] flex h-10 items-center gap-4">
        {totalLabel !== undefined && (
          <span className="text-sm text-foreground-muted" aria-live="polite">
            {totalLabel}
          </span>
        )}
        <Button
          variant="secondary"
          size="sm"
          leftIcon={<SlidersHorizontal size={14} />}
          onClick={onOpenFilters}
        >
          {t('filtros.avancados')}
        </Button>
        {actions}
      </div>
    </div>
  );
}
